// extracted by mini-css-extract-plugin
export default {"container":"headline_container__MU+Ur","headline1":"headline_headline1__EnHDA","headline3":"headline_headline3__TRMod","headline2":"headline_headline2__E1kXo"};